import React from 'react';
import * as types from '../constants/action-types';
import { get } from 'lodash';
import { Tags } from '../../../../api/api-tags';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../../shared-components/hocs/sharedIntlProviderHOC';

export function fetchSpaceTagsRequest () {
  return {
    type: types.SPACE_TAGS_FETCH_REQUEST
  };
}

export function fetchSpaceTagsSuccess (data) {
  return {
    type: types.SPACE_TAGS_FETCH_SUCCESS,
    data
  };
}

function fetchSpaceTagsFailure (fetchError) {
  return {
    type: types.SPACE_TAGS_FETCH_FAILURE,
    fetchError
  };
}

export function fetchSpaceTags () {
  const locale = SharedIntlProviderHOC.getLocale();

  return dispatch => {
    dispatch(fetchSpaceTagsRequest());

    return new Promise((resolve, reject) => {
      return Tags.read(locale, response => {
        if (200 === response.statusCode) {
          dispatch(fetchSpaceTagsSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'message', (<FormattedMessage id="hosting.space_tags.error_message" defaultMessage="Something went wrong, please try again."/>));
        dispatch(fetchSpaceTagsFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}
